import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveFilter as _resolveFilter, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "modern-list-card"
};
const _hoisted_2 = {
  class: "modern-list-thumb-col"
};
const _hoisted_3 = {
  class: "modern-list-thumb-wrap"
};
const _hoisted_4 = {
  class: "modern-list-thumb-overlay"
};
const _hoisted_5 = {
  class: "modern-list-play-button"
};
const _hoisted_6 = {
  key: 1,
  class: "modern-featured-badge"
};
const _hoisted_7 = {
  class: "modern-list-body"
};
const _hoisted_8 = {
  class: "modern-list-header"
};
const _hoisted_9 = {
  class: "modern-list-title-wrap"
};
const _hoisted_10 = {
  class: "modern-list-title"
};
const _hoisted_11 = {
  key: 0,
  class: "modern-list-meta-top"
};
const _hoisted_12 = {
  class: "modern-owner-line"
};
const _hoisted_13 = {
  class: "modern-ensemble-line"
};
const _hoisted_14 = {
  class: "modern-list-actions-top"
};
const _hoisted_15 = {
  key: 0,
  class: "modern-tag-row"
};
const _hoisted_16 = ["href"];
const _hoisted_17 = {
  class: "modern-tag-more"
};
const _hoisted_18 = {
  class: "modern-list-icon-row"
};
const _hoisted_19 = ["title"];
const _hoisted_20 = ["title"];
const _hoisted_21 = {
  class: "modern-list-info-panel"
};
const _hoisted_22 = {
  class: "modern-video-owner mb-2"
};
const _hoisted_23 = {
  class: "modern-video-description"
};
const _hoisted_24 = {
  class: "mb-0"
};
const _hoisted_25 = {
  class: "modern-program-link"
};
const _hoisted_26 = ["href"];
const _hoisted_27 = {
  class: "mb-1 modern-comp-title"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = {
  key: 0,
  class: "list-inline mb-0 small"
};
const _hoisted_31 = {
  key: 1,
  class: "list-inline mb-0 small"
};
const _hoisted_32 = {
  class: "list-inline-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_b_img = _resolveComponent("b-img");
  const _component_b_badge = _resolveComponent("b-badge");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_input_group_append = _resolveComponent("b-input-group-append");
  const _component_b_input_group = _resolveComponent("b-input-group");
  const _component_b_dropdown_text = _resolveComponent("b-dropdown-text");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  const _component_b_overlay = _resolveComponent("b-overlay");
  const _directive_b_popover = _resolveDirective("b-popover");
  const _filter_stringMax = _resolveFilter("stringMax");
  return _openBlock(), _createBlock(_component_b_overlay, {
    show: _ctx.favoriteLoading,
    opacity: "0.6",
    "spinner-variant": "primary",
    "no-fade": "",
    rounded: "",
    class: "video-list-overlay"
  }, {
    default: _withCtx(() => [_createElementVNode("article", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!$props.video.noView ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      class: "modern-list-thumb-link",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('play'), ["prevent"])),
      href: ""
    }, [_createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_b_icon, {
      icon: "play-fill"
    })])), [[_directive_b_popover, !$props.preview ? 'Watch Now' : 'Subscribe Now', void 0, {
      hover: true,
      top: true
    }]])])])) : _createCommentVNode("", true), $props.video.video.featured > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Featured ")) : _createCommentVNode("", true), $props.video.thumbError ? (_openBlock(), _createBlock(_component_b_img, {
      key: 2,
      src: "https://placehold.it/960x550?text=Spin+Network",
      class: "modern-list-thumb",
      alt: $props.video.video.title
    }, null, 8, ["alt"])) : (_openBlock(), _createBlock(_component_b_img, {
      key: 3,
      src: $props.video.thumbnail_link,
      class: "modern-list-thumb",
      title: $props.video.video.title,
      alt: $props.video.video.title
    }, null, 8, ["src", "title", "alt"]))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("h5", _hoisted_10, [_createTextVNode(_toDisplayString(_filter_stringMax($props.video.video.title, 60)) + " ", 1), _withDirectives(_createVNode(_component_b_badge, {
      variant: "primary",
      class: "ms-2"
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("NEW", -1)]))], undefined, true),
      _: 1
    }, 512), [[_vShow, $props.video.new]])]), $props.video.video.ensemble.id !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($props.video.video.ensemble.organization.name), 1), _createElementVNode("div", _hoisted_13, _toDisplayString($props.video.video.ensemble.name), 1), _withDirectives(_createElementVNode("div", {
      class: "modern-channel-line"
    }, " Channel: " + _toDisplayString($props.video.video.organization.name), 513), [[_vShow, $props.video.video.organization_id !== $props.video.video.ensemble.organization_id]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_b_dropdown, {
      placement: "top-start",
      "toggle-class": "text-decoration-none modern-share-toggle",
      variant: "link",
      "no-caret": "",
      class: "modern-share-dropdown"
    }, _createSlots({
      default: _withCtx(() => [_createVNode(_component_b_dropdown_text, null, {
        default: _withCtx(() => [_createVNode(_component_b_input_group, {
          size: "sm"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_form_input, {
            readonly: "",
            modelValue: _ctx.videolink,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.videolink = $event)
          }, null, 8, ["modelValue"]), _createVNode(_component_b_input_group_append, null, {
            default: _withCtx(() => [_createVNode(_component_b_button, {
              size: "sm",
              onClick: _cache[2] || (_cache[2] = $event => $options.copy())
            }, {
              default: _withCtx(() => [_createVNode(_component_b_icon, {
                icon: "clipboard"
              })], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], undefined, true),
      _: 2
    }, [!$props.preview ? {
      name: "button-content",
      fn: _withCtx(() => [_createVNode(_component_b_button, {
        class: "modern-share-btn"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_icon, {
          icon: "share-fill"
        }), _cache[6] || (_cache[6] = _createTextVNode(" Share ", -1))], undefined, true),
        _: 1
      })]),
      key: "0"
    } : undefined]), 1024)])]), $props.video.video.ensemble.id !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [!$props.preview ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList($options.sharedTags, (val, i) => {
      return _withDirectives((_openBlock(), _createElementBlock("a", {
        href: '/video?text_search=' + val.tag,
        key: i,
        class: "modern-tag-link"
      }, [_createVNode(_component_b_badge, {
        pill: "",
        variant: "light",
        class: "modern-tag-badge"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_filter_stringMax(val.tag, 34)), 1)], undefined, true),
        _: 2
      }, 1024)], 8, _hoisted_16)), [[_directive_b_popover, 'Search For', void 0, {
        hover: true,
        top: true
      }]]);
    }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList($options.sharedTags, (val, i) => {
      return _openBlock(), _createElementBlock("span", {
        key: i,
        class: "modern-tag-link"
      }, [_createVNode(_component_b_badge, {
        pill: "",
        variant: "light",
        class: "modern-tag-badge"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_filter_stringMax(val.tag, 34)), 1)], undefined, true),
        _: 2
      }, 1024)]);
    }), 128)), _withDirectives(_createElementVNode("span", _hoisted_17, " ... ", 512), [[_vShow, $props.video.video.sharedTag && $props.video.video.sharedTag.length > 6]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [!$props.video.noView && !$props.preview ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      href: "",
      onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.favorite(), ["prevent"])),
      class: "modern-icon-action favorite",
      title: _ctx.localFavorite ? 'Remove Favorite' : 'Add Favorite'
    }, [_createVNode(_component_b_icon, {
      icon: _ctx.localFavorite ? 'heart-fill' : 'heart'
    }, null, 8, ["icon"])], 8, _hoisted_19)) : _createCommentVNode("", true), _createElementVNode("a", {
      href: "",
      onClick: _cache[4] || (_cache[4] = _withModifiers($event => _ctx.showInfo = _ctx.showInfo ? 0 : 1, ["prevent"])),
      class: "modern-icon-action",
      title: _ctx.showInfo ? 'Hide Info' : 'Video Info'
    }, [_createVNode(_component_b_icon, {
      icon: _ctx.showInfo ? 'x-circle-fill' : 'info-circle-fill'
    }, null, 8, ["icon"])], 8, _hoisted_20)]), _withDirectives(_createElementVNode("div", _hoisted_21, [_createElementVNode("p", _hoisted_22, " Video Owner: " + _toDisplayString($props.video.video.organization.name), 1), _withDirectives(_createElementVNode("div", _hoisted_23, [_createElementVNode("p", _hoisted_24, _toDisplayString($props.video.video.description), 1)], 512), [[_vShow, $props.video.video.description.length > 0]]), _withDirectives(_createElementVNode("div", _hoisted_25, [_createElementVNode("a", {
      href: $props.video.video.programlink,
      target: "_blank"
    }, " Program Link ", 8, _hoisted_26)], 512), [[_vShow, $props.video.video.programlink && $props.video.video.programlink !== '' && !$props.preview]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.video.video.ownVideocomposition, vc => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: vc.id,
        class: "modern-comp-card"
      }, [_createElementVNode("p", _hoisted_27, [vc.composition_id > 0 ? (_openBlock(), _createElementBlock("b", _hoisted_28, _toDisplayString(vc.composition.title), 1)) : _createCommentVNode("", true), vc.composition_id == null ? (_openBlock(), _createElementBlock("b", _hoisted_29, _toDisplayString(vc.newtitle), 1)) : _createCommentVNode("", true)]), vc.composition && vc.composition.sharedComposer.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [_cache[7] || (_cache[7] = _createElementVNode("li", {
        class: "list-inline-item"
      }, "Written by:", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vc.composition.sharedComposer, (co, key) => {
        return _openBlock(), _createElementBlock("li", {
          class: "list-inline-item",
          key: key
        }, [_createTextVNode(_toDisplayString(co.name), 1), _withDirectives(_createElementVNode("span", null, ", ", 512), [[_vShow, key !== Object.keys(vc.composition.sharedComposer).length - 1]])]);
      }), 128))])) : _createCommentVNode("", true), vc.composition_id == null && vc.newcomposer !== null ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [_cache[8] || (_cache[8] = _createElementVNode("li", {
        class: "list-inline-item"
      }, "Written by:", -1)), _createElementVNode("li", _hoisted_32, _toDisplayString(vc.newcomposer), 1)])) : _createCommentVNode("", true)])), [[_vShow, $props.video.video.ensemble.id !== 1 && !$props.preview]]);
    }), 128))], 512), [[_vShow, _ctx.showInfo]])])])], undefined, true),
    _: 1
  }, 8, ["show"]);
}